__turbopack_context__.v({
  "popularBrandsWrapper": "styles-module__htT3Yq__popularBrandsWrapper",
  "resultsTotalCount": "styles-module__htT3Yq__resultsTotalCount",
  "wrapper": "styles-module__htT3Yq__wrapper",
});
